// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "e337806a64e57e8993e8053ba14aa48f" + ".js";
};